<template>
  <div class="container mx-auto">
    <!-- Search field  & Filter-->
    <div class="grid grid-cols-1 md:grid-cols-2">
      <div class="mx-4">
        <p class="text-left mt-2 text-xs font-extralight">Vyhľadávanie</p>
        <input
          class="inline-block border border-gray-500 w-full py-3 px-3 my-2 text-lg text-left rounded-md"
          type="text"
          v-model="searchQuery"
          name="search"
          placeholder="Hľadať podľa mesta alebo názvu predajcu..."
        />
      </div>
      <div>
        <p class="text-left mt-2 mx-4 md:mx-0 text-xs font-extralight">Vybrané krajiny</p>
        <button
          class="md:text-lg inline-block border border-gray-500 rounded-md mx-4 my-2 md:px-4 px-3 py-3"
          :class="{
            'bg-green-400 border-green-300 text-white hover:bg-transparent hover:text-gray-500 hover:border-gray-500':
              countries.includes('sk'),
            'hover:bg-green-400 hover:border-green-300 hover:text-white': !countries.includes('sk'),
          }"
          @click="filterCountry('sk')"
        >
          Slovensko {{ countries.includes("sk") ? "ⓧ" : "" }}
        </button>
        <button
          class="md:text-lg inline-block border border-gray-500 rounded-md mx-4 my-2 md:px-4 px-3 py-3"
          :class="{
            'bg-green-400 border-green-300 text-white hover:bg-transparent hover:text-gray-500 hover:border-gray-500':
              countries.includes('mr'),
            'hover:bg-green-400 hover:border-green-300 hover:text-white': !countries.includes('mr'),
          }"
          @click="filterCountry('mr')"
        >
          Morava {{ countries.includes("mr") ? "ⓧ" : "" }}
        </button>
        <button
          class="md:text-lg inline-block border border-gray-500 rounded-md mx-4 my-2 md:px-4 px-3 py-3"
          :class="{
            'bg-green-400 border-green-300 text-white hover:bg-transparent hover:text-gray-500 hover:border-gray-500':
              countries.includes('cz'),
            'hover:bg-green-400 hover:border-green-300 hover:text-white': !countries.includes('cz'),
          }"
          @click="filterCountry('cz')"
        >
          Česko {{ countries.includes("cz") ? "ⓧ" : "" }}
        </button>
      </div>
    </div>

    <!-- List of distributors -->
    <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 p-2">
      <div
        class="container bg-gray-100 hover:bg-gray-200 p-2 rounded-md mx-auto"
        v-for="{ id, store_name, store_address, city, country } in filterDistributors()"
        :key="id"
        v-show="countries.includes(country)"
      >
        <h2 class="font-semibold text-xl text-left">{{ store_name }}</h2>
        <p v-if="store_address" class="text-left text-xs font-extralight">Adresa predajne</p>
        <p class="text-left text-lg">{{ store_address }}</p>
        <p v-if="city" class="text-left text-xs font-extralight">Mesto</p>
        <p class="text-left text-lg">{{ city }}</p>
        
        
      </div>
      <h2 v-if="filterDistributors().length == 0 || countries.length == 0" class="font-semibold text-xl text-left">Ľutujeme, ale pre zvolené kritéria nemáme žiadne predajne</h2>
    </div>
  </div>
</template>

<script>
import { useLoadDistributors } from "../firebase";
import { ref, reactive } from "vue";

export default {
  setup() {
    // Array of distributors
    var distributors = useLoadDistributors();
    // Filter query (free text field)
    const searchQuery = ref("");
    const countries = reactive(["sk", "mr", "cz"]);

    // Free text field filter
    function filterDistributors() {
      if (searchQuery.value) {
        return distributors.value
          .filter(
            (distributor) =>
              distributor.store_name.toLowerCase().includes(searchQuery.value.toLowerCase()) ||
              distributor.city.toLowerCase().includes(searchQuery.value.toLowerCase())
          )
          .sort(sortDistributor);
      } else {
        return distributors.value.sort(sortDistributor);
      }
    }

    // Country filter
    function filterCountry(val) {
      // Either add country to array or remove it if already exists
      if (!countries.includes(val)) {
        countries.push(val);
      } else {
        var position = countries.indexOf(val);
        countries.splice(position, 1);
      }
    }

    // Internal function for sorting distributors by country code
    function sortDistributor(a, b) {
      if (a.country > b.country) {
        return -1;
      }
      if (a.country < b.country) {
        return 1;
      }
      return 0;
    }

    return { distributors, searchQuery, countries, filterDistributors, filterCountry };
  },
};
</script>
